import React from "react";
import { AlertTriangle } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export function MediaDeleteDialog({ item, usedIn, onCancel, onConfirm }: { item: any; usedIn: any[]; onCancel: () => void; onConfirm: () => void }) {
  return (
    <Dialog open={!!item} onOpenChange={(v) => !v && onCancel()}>
      <DialogContent className="bg-white max-w-md" data-testid="media-delete-warning">
        <DialogTitle className="font-display text-2xl flex items-center gap-2"><AlertTriangle size={20} className="text-amber-600" />Photo still in use</DialogTitle>
        {item && <img src={item.url} alt="" className="w-24 h-24 object-cover border" />}
        <p className="text-sm text-neutral-700">Deleting it will leave a blank space in these places:</p>
        <ul className="text-sm space-y-1.5 max-h-48 overflow-y-auto" data-testid="media-usage-list">
          {usedIn.map((u, i) => (
            <li key={i} className="flex gap-2"><span className="text-[10px] uppercase tracking-wider text-neutral-500 w-20 flex-none pt-0.5">{u.type}</span>
              <a href={u.url} target="_blank" rel="noreferrer" className="underline">{u.title}</a></li>
          ))}
        </ul>
        <div className="flex justify-end gap-3 pt-2">
          <button type="button" onClick={onCancel} className="border border-neutral-300 px-4 py-2 text-xs uppercase tracking-wider" data-testid="media-delete-cancel">Keep photo</button>
          <button type="button" onClick={onConfirm} className="bg-red-800 text-white px-4 py-2 text-xs uppercase tracking-wider" data-testid="media-delete-confirm">Delete anyway</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
